import { UseQueryResult } from '@tanstack/react-query'
import { BizCouponCountResData, getBizCouponCount } from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'

import { KEYS } from '../keys'

interface Props {
  useErrorBoundary?: boolean
}

function useGetBizCouponCount(props: Props): UseQueryResult<BizCouponCountResData, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)

  return useQueryWrapper<BizCouponCountResData, AxiosError>(
    KEYS.BIZ_COUPON(),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get('/api/v1/internal/my/coupon-count')
        return data
      } else {
        const { data } = await getBizCouponCount()
        return data
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetBizCouponCount }
